import request from '@/utils/request'

export function selfProfileGetItem() {
  return request({
    url: '/Profile/Get',
    method: 'post',
    data: {},
  })
}

export function getItem(data) {
  return request({
    url: '/User/Get',
    method: 'post',
    data: { id: data },
  })
}

export function login(data) {
  console.log('api login', data)

  return request({
    url: '/User/Login',
    method: 'post',
    data,
  })
}
export function logout() {
  return request({
    url: '/User/Logout',
    method: 'post',
  })
}
export function fetchList(data) {
  return request({
    url: '/User/List',
    method: 'post',
    data,
  })
}

export function listStudent(data) {
  return request({
    url: '/User/ListStudent',
    method: 'post',
    data,
  })
}

export function createItem(data) {
  console.log('createItem', data)

  return request({
    url: '/User/Create',
    method: 'post',
    data,
  })
}

export function updateItem(data) {
  console.log('updateItem', data)

  return request({
    url: '/User/Update',
    method: 'post',
    data,
  })
}

export function deleteItem(data) {
  return request({
    url: '/User/Delete',
    method: 'delete',
    data,
  })
}

export function createStudent(data) {
  return request({
    url: '/User/CreateStudent',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export function createCoach(data) {
  return request({
    url: '/User/createCoach',
    method: 'post',
    data,
  })
}

export function fetchCoachList(data) {
  return request({
    url: '/User/CoachList',
    method: 'post',
    data,
  })
}

export function getCoachItem(data) {
  return request({
    url: '/User/GetCoachItem',
    method: 'post',
    data,
  })
}


export function Activation(data) {
  return request({
    url: '/User/Activation',
    method: 'post',
    data  
  })
}

export function ForgetPassword(data) {
  return request({
    url: '/User/ForgetPassword',
    method: 'post',
    data  
  })
}

export function ConfirmVerify(data) {
  return request({
    url: '/User/ConfirmVerify',
    method: 'post',
    data  
  })
}

export function ChangePassword(data) {
  return request({
    url: '/User/ChangePassword',
    method: 'post',
    data  
  })
}



export function ExcelReportList() {
  return request({
    url: '/User/ExcelReportList',
    method: 'post',
    data: { page : 0 , limit: 0},  
  })
}
